/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableHeader, TableHeadersMeta } from 'src/app/core/interfaces/table.interface';
import { TableResponsiveService } from 'src/app/core/services/table-responsive.service';

@Component({
  selector: 'app-table-v1',
  templateUrl: './table-v1.component.html',
  styleUrl: './table-v1.component.scss'
})
export class TableV1Component {
  @Input({ required: true }) tableHeader: TableHeadersMeta;
  @Input({ required: false }) currentOrderBy?: string;
  @Input({ required: true }) selectStates: 'all' | 'some' | 'none';

  @Output() onSort = new EventEmitter<TableHeader>();
  @Output() onSelectAll = new EventEmitter<boolean>();

  @Input({ required: false }) maxVisibleColumns: number = Infinity;
  detailRowIndex: number | null = null;

  constructor(private tableResposiveService: TableResponsiveService) { }

  ngOnInit() {
    if (this.maxVisibleColumns === Infinity) {
      this.tableResposiveService.maxVisibleColumns$.subscribe((maxVisibleColumns) => {
        this.maxVisibleColumns = maxVisibleColumns;
      })
    }
  }

  toggleSelectAll() {
    const isSelectAll = this.selectStates === 'all' ? false : true;
    this.onSelectAll.emit(isSelectAll);
  }

  getKey(header: TableHeader) {
    if (typeof header.key === 'function') {
      return header.key();
    }
    return header.key;
  }

  get visibleHeaders(): TableHeader[] {
    if (this.tableHeader.headers.length > this.maxVisibleColumns) {
      return this.tableHeader.headers.slice(0, this.maxVisibleColumns);
    }
    return this.tableHeader.headers;
  }

  get hiddenHeaders(): TableHeader[] {
    if (this.tableHeader.headers.length > this.maxVisibleColumns) {
      return this.tableHeader.headers.slice(this.maxVisibleColumns);
    }
    return [];
  }

  toggleDetailRow(rowIndex: number) {
    if (this.detailRowIndex === rowIndex) {
      this.detailRowIndex = null;
    } else {
      this.detailRowIndex = rowIndex;
    }
  }

  closeDetailRow() {
    this.detailRowIndex = null;
  }
}
